import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AnsiUp } from 'ansi_up';

import { NotebookVizResult } from '@mode/notebooks/domain';

@Directive({
  selector: '[modeNotebookCellResultContent]',
})
export class NotebookCellResultContentDirective implements OnInit {
  @Input()
  modeNotebookCellResultContent!: NotebookVizResult;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    const ansi_up = new AnsiUp();

    ansi_up.use_classes = true;
    this.el.nativeElement.innerHTML = ansi_up.ansi_to_html(this.modeNotebookCellResultContent.content.toString());
  }
}
